/** @jsx jsx */
import { jsx, Container } from 'theme-ui'
import { FC } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'
import HeadingV2 from '~/componentsV2/heading'

type Props = {
  title: string
  description?: string
}

const SimpleContent: FC<Props> = ({ title }) =>
  (
    <Container>
      <HeadingV2
        level="1"
        className="simple-content__title"
        sx={{
          textAlign: 'initial',
          mt: ['16px', space.md3],
          mb: 0,
          textTransform: 'uppercase',
          fontSize: '2rem !important',
        }}
      >
        {title}
      </HeadingV2>
    </Container>
  ) as JSX.Element

export default SimpleContent
